import {Account, Client} from 'appwrite';

export const client = new Client();

export const database_id = "6771098900254ec19571"

client
    .setEndpoint('https://cloud.appwrite.io/v1')
    .setProject('67232f8c003094e2430c'); // Replace with your project ID


export const account = new Account(client);
export {ID} from 'appwrite';